import { computed, inject, provide, ref, type ComputedRef, type InjectionKey, type Ref } from "vue";

type FormLoadingContext = {
  pendingCount: Ref<number>;
};

const FORM_LOADING_KEY: InjectionKey<FormLoadingContext> = Symbol("formLoading");

export const provideFormLoading = (): ComputedRef<boolean> => {
  const pendingCount = ref(0);

  provide(FORM_LOADING_KEY, { pendingCount });

  return computed(() => pendingCount.value > 0);
};

export const useTrackFormLoading = (): (<T>(request: Promise<T>) => Promise<T>) => {
  const context = inject(FORM_LOADING_KEY, null);

  return async <T>(request: Promise<T>): Promise<T> => {
    if (!context) {
      return request;
    }

    context.pendingCount.value += 1;

    try {
      return await request;
    } finally {
      context.pendingCount.value -= 1;
    }
  };
};

export const useFormLoadingPending = (): ComputedRef<boolean> => {
  const context = inject(FORM_LOADING_KEY, null);

  return computed(() => (context ? context.pendingCount.value > 0 : false));
};
